import { Component } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { OnGetData } from '../../../services/dialog.service';
import { RadioButtonComponent } from '../../../shared-extra/components/radio-button/radio-button.component';
import { RadioComponent } from '../../../shared-extra/components/radio/radio.component';
import { BillingScopePipe } from '../../../shared-extra/pipes/billing-scope.pipe';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';

@Component({
  selector: 'app-duplicate-assets-dialog',
  templateUrl: './duplicate-assets-dialog.component.html',
  standalone: true,
  imports: [SvgComponent, ButtonDirective, RadioButtonComponent, BillingScopePipe, RadioComponent, TooltipDirective],
  styleUrls: ['./duplicate-assets-dialog.component.scss'],
})
export class DuplicateAssetsDialogComponent implements OnGetData {
  dialogName = 'duplicate-assets';
  close: (...args) => void;
  gallery: GalleryDto;
  duplicates: string[];
  action = 'skip';
  allowedActions: ('skip' | 'override' | 'new_assets')[];
  textType: 'upload' | 'move' | 'copy';

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40 };
  }

  onGetData(
    data: {
      gallery: GalleryDto;
      duplicates: string[];
      allowedActions?: typeof this.allowedActions;
      textType?: typeof this.textType;
    },
    close: (...args) => void
  ) {
    this.gallery = data.gallery;
    this.duplicates = data.duplicates;
    this.allowedActions = data.allowedActions || ['skip', 'override', 'new_assets'];
    this.action = this.allowedActions[0];
    this.textType = data.textType || 'upload';
    this.close = close;
  }

  confirm() {
    this.close(this.action);
  }
}
